import React, { Component } from "react";
import DetailsTelahMengisiLengkap from "../../component/detail-kebijakan/DetailsTelahMengisiLengkap";
class YangMengisiLengkap extends Component {
    render(){
        return(
            <>
                <DetailsTelahMengisiLengkap/>
            </>
        )
    }
}
export default YangMengisiLengkap;